module.exports = __webpack_public_path__ + "img/homme.a44776f2.png";